import { highlightTitleWords } from '@helpers/utils';
import { withMotion } from '@hoc/withMotion';
import FloatingBackgroundElements from '@stories/Components/Misc/FloatingBackgroundElements/FloatingBackgroundElements';
import React from 'react';
import Breadcrumbs from '../Global/Breadcrumbs/Breadcrumbs';
import { PremiumResourceBannerStyles as S } from './PremiumResourceBanner.styles';
const PremiumResourceBanner = ({ title, breadcrumbs, introduction, }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(S.WrapperStyles, null),
        React.createElement(FloatingBackgroundElements, { keyFix: "inner-page-banner", startPositions: [
                { x: `-20%`, y: `40%` },
                { x: `15%`, y: `-30%` },
                { x: `50%`, y: `-30%` },
            ] }),
        React.createElement(S.LeftContent, null,
            breadcrumbs && React.createElement(Breadcrumbs, { items: breadcrumbs, layout: "embedded" }),
            React.createElement(S.Title, { dangerouslySetInnerHTML: { __html: highlightTitleWords(title) } }),
            introduction && React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: introduction } }))));
};
export default withMotion(PremiumResourceBanner);
